<template>
  <div id="app">
    <nav class="breadcrumb" aria-label="breadcrumbs">
      <ul>
        <li><a href="/">Домой</a></li>
        <li class="is-active"><a class="has-text-white">Новости</a></li>
      </ul>
    </nav>

    <ArticlePreview
      v-for="article in news"
      v-bind:key="article.id"
      v-bind:article="article"
    />
  </div>
</template>

<script>
import NewsService from '../../services/NewsService'
import ArticlePreview from '../components/ArticlePreview'

export default {
  components: {
    ArticlePreview
  },
  data() {
    return {
      news: [],
    };
  },
  created() {
    this.loadNews()
  },
  methods: {
    async loadNews() {
      const resp = await NewsService.getNews()
      this.news = resp.data
    }
  },
};
</script>

<style scoped></style>
